














import {Component, Vue} from 'vue-property-decorator'
import DeviceTaskView from "@/view/device-manage/device/task.vue"
import DeviceTaskGeneratorView from "@/view/device-manage/device/task-generator.vue";

@Component({
  components: {
    DeviceTaskView,
    DeviceTaskGeneratorView
  },
})
export default class DeviceTaskWrapperView extends Vue {

  private view = 'tv'

  private loadProduct = false

  private handleChange(view: string) {
    if (view == 'tgv')
      this.loadProduct = true
  }
}
